<!--
SenbBee2 button

An extension of bootstrap buttons. Supports showing a spinner when "loading" prop is true

@param [loading]  - Should button be in loading state
@param [disabled] - Should button be in disabled state
@param [variant]  - Button variation (see bootstrap buttons)
    "primary" - blue button, default

Supported events:
@click - as per bootstrap-vue docs, "Emitted when non-disabled button clicked"

Usage:
<sb2-button
  :loading="some_component_property"
  :disabled="false"
  @click="click_handler_function">
  Button content: Some text or <div>element</div> or mix
</sb2-button>


-->
<template>
  <b-button
    :class="{loading: loading}"
    :disabled="disabled"
    :variant="variant"
    class="sb2-button"
    @click="$emit('click')">
    <span class="sb2-button--content">
      <slot name="default"></slot>
    </span>
    <Spinner
      v-if="loading"
      :size="14"
      :thickness="2"
      :color="SBColors.white" />
  </b-button>
</template>

<script>
import SBColors from '../../helpers/lists/colors';
import Spinner from './Spinner';

export default {
  name: 'sb2Button',
  components: {
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      required: false,
      default: 'primary',
      validator(value) {
        // The value must match one of these strings
        return ['primary'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      SBColors,
    };
  },
};
</script>

<style lang="scss">
/* @todo: move this to a global CSS file */
  .sb2-button {
    // hide content when loading but keep spacing
    &.loading .sb2-button--content {
      visibility: hidden;
    }

    // center spinner
    .loader {
      position: absolute;
      height: 100%;
      display: flex;
      align-items: center;
    }

    // variations
    // supporting only "primary" variant for now
    &.btn.btn-primary {
      // copied style from src/assets/css/layout/_settings-sections.scss:87
      // that's why it's full of "!important"
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15) !important;
      background-color: $bluePrimary !important;
      color: $white !important;
      position: relative !important;
      border: 1px solid $bluePrimary !important;

      &:hover, &:focus, &:active {
        background-color: $bluePrimary !important;
        border: 1px solid $bluePrimary !important;
        color: $white !important;
      }

      &:disabled {
        opacity: 1 !important;

        &:not(.loading) {
          background: $greyLight !important;
          border: 1px solid $greyLight !important;
          &:hover {
            background: $greyLight !important;
            border: 1px solid $greyLight !important;
          }
        }
      }
    }
  }
</style>
